import cn from 'classnames';
import MeshBackground from 'react-scale/components/ui/webgl';
import CTA from 'react-scale/components/ui/cta';

import PropTypes from 'prop-types';

const Hero = ({ overtitle, title, product, subtitle, cta, bgAnimated, children }) => (
  <div className="text-white bg-black">
    {bgAnimated && <MeshBackground />}
    <div className="relative">
      <div className="container flex flex-col items-center w-full py-10 lg:flex-row lg:gap-10 lg:py-32">
        <div className={cn('w-full', product ? 'lg:w-5/12' : 'lg:w-6/12')}>
          {overtitle && (
            <h4 className="inline-block mb-4 text-overtitle-sm text-gradient">{overtitle}</h4>
          )}
          <h1
            className={cn(
              'font-light font-aeonik',
              product ? 'text-5xl md:text-7xl' : 'text-4xl md:text-6xl'
            )}
          >
            {title}{' '}
            {product && <span className="text-gradient box-decoration-clone">{product}</span>}
          </h1>
          <p className={cn('mt-6 text-base lg:text-xl', product ? 'lg:w-3/4' : 'w-full')}>
            {subtitle}
          </p>
          <div className="mt-12 mb-12 lg:w-3/4 lg:mb-0">
            <CTA cta={cta} />
          </div>
        </div>
        <div className={cn('flex-shrink w-full', product ? 'lg:w-7/12' : 'lg:w-6/12')}>
          {children}
        </div>
      </div>
    </div>
  </div>
);

Hero.propTypes = {
  bgAnimated: PropTypes.bool
};

Hero.defaultProps = {
  bgAnimated: true
};

export default Hero;
